import { createFormHookContexts } from '@tanstack/react-form'

export const {
  fieldContext: FormFieldContext,
  formContext: FormContext,
  useFieldContext: useFormFieldContext,
  useFormContext,
} = createFormHookContexts()
